// The purpose of this file is store form field constraints (rules, messages) for a HTML form.
// Note that this data is kept separate from the implementation of the system that stores and retrieves data,
// which is located in the 'core' directory.

// Grab a reference to the application data store object.
var dataStore = app.data;

// Create data and store it. Note that validation messages should be overriden by the server
// in the cshtml view files, to cater for different languages. The message values here are just fallbacks.
// Things should take the format of: fieldName[validatorType] = { message: "My custom message" } as per https://validatejs.org/

dataStore.set('validation.registerForm', {

    firstNameInput: [
        {
            type: 'present',
            errorCode: 10008
        }
    ],
    lastNameInput: [
        {
            type: 'present',
            errorCode: 10037
        }
    ],
    isOver18Checkbox: [
        {
            type: 'present',
            errorCode: 10038
        }
    ],
    emailAddressInput: [
        {
            type: 'present',
            errorCode: 10046
        },
        {
            type: 'email',
            errorCode: 10056
        },
        {
            type: 'notInArray',
            params: {
                // The disallowedValues array is populated later,
                // as the user interacts with the form, and the server receives
                // reserved email addresses via AJAX.
                disallowedValues: []
            },
            errorCode: 10057
        }
    ],
    phoneRegionCodeSelect: [
        {
            type: 'present',
            errorCode: 10039
        }
    ],
    phoneNumberInput: [
        {
            type: 'present',
            errorCode: 10045
        }
    ],
    passwordInput: [
        {
            type: 'present',
            errorCode: 10058
        },
        {
            type: 'minLength',
            params: {
                size: 6,
            },
            errorCode: 10006
        },
        {
            type: 'strongPassword',
            errorCode: 10006
        }
    ],
    confirmPasswordInput: [
        {
            type: 'present',
            errorCode: 10040
        },
        {
            type: 'confirmed',
            params: {
                comparatorFieldId: "passwordInput"
            },
            errorCode: 10041
        }
    ],
    universityNameInput: [
        {
            type: 'present',
            errorCode: 10042
        }
    ],
    territoryInput: [
        {
            type: 'present',
            errorCode: 10007
        },
    ],
    degreeSubjectInput: [
        {
            type: 'present',
            errorCode: 10043
        },
    ],
    certificateUpload: [
        {
            type: 'fileType',
            params: {
                validExtensions: ['pdf', 'doc', 'docx', 'jpeg', 'jpg']
            },
            errorCode: 10029
        },
        {
            type: 'maxFileSize',
            params: {
                size: 5 // 5MB
            },
            errorCode: 10028
        },
        {
            type: 'minFiles',
            params: {
                size: 1
            },
            errorCode: 10027
        },
        {
            type: 'maxFiles',
            params: {
                size: 1
            },
            errorCode: 10055
        }
    ],
    termsAndConditionsCheckbox: [
        {
            type: 'present',
            errorCode: 10044
        }
    ],
    profileType: [
        {
            type: 'present',
            errorCode: 10091
        }
    ]

});